import { Button } from '@amzn/awsui-components-console';
import {
  Resource,
  ResourceAction,
  useHasResourcePermission,
} from '@hooks/useHasResourcePermission';
import { useAppDispatch } from '@stores/slices/hooks';
import { toggleShowDeviceLinkFileUpload } from '@stores/slices/userSlice';
import React from 'react';

export function LinkDevicesButton(): React.ReactElement {
  const dispatch = useAppDispatch();
  const { hasPermission: hasDeviceLinkPermissions } = useHasResourcePermission(
    Resource.DeviceLink,
    ResourceAction.Write
  );

  return (
    <Button
      className="ninetyWidth"
      disabled={!hasDeviceLinkPermissions}
      disabledReason="Missing Link Devices permissions"
      onClick={(): void => {
        dispatch(toggleShowDeviceLinkFileUpload());
      }}
      iconName="upload"
      ariaLabel="Link Devices">
      Link Device(s)
    </Button>
  );
}
